<template>
    <div class="content">
        <a-spin class="load" v-show="loading" />
        <h1 class="title" v-html="mess.title"></h1>
        <div class="author">{{mess.authorName}}</div>
        <div class="w-e-text" v-html="mess.content"></div>
    </div>
</template>

<script>
// import pdf from 'vue-pdf'
export default {
  name: 'snailBookListDetail',
  data () {
    return {
      mess: {},
      loading: false
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      console.log('getDetail', 'ebook/teacher/article/getArticleInfo')
      const param = {
        id: sessionStorage.getItem('snailsID') || ''
      }
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/article/getArticleInfo',
        body: param
      }).loading(
        () => (_this.loading = true),
        () => (_this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.mess = res.resultData
          console.log('getDetail', _this.mess)
          // if(!res.resultData.content||res.resultData.content == 'null'){
          //     const a = document.createElement('a')
          //     a.setAttribute('href', this.$resBasePath+'/'+res.resultData.fileList[0].path)
          //     a.setAttribute('target', '_blank')
          //     window.open(a)
          // }
        }
      })
    }
  },
  components: {
    // pdf
  }
}
</script>

<style lang="less" scoped>
    .content{
        margin: 0;
        padding: 0 70px;
        position: relative;
        .load{
            position: absolute;
            top: 25%;
            left: 50%;
            transform: translate(50%, 50%);
            z-index: 99;
        }
        .title{
            text-align: center;
            margin-top: 20px;
            color: #333;
            font-size: 22px;
            font-family: "Microsoft YaHei";
        }
        .author{
            text-align: center;
            line-height: 40px;
            color: #333;
            font-size: 18px;
            font-family: "Microsoft YaHei";
        }
        .text{
            padding-top: 10px;
        }
    }
    /deep/table{
        border:1px solid #ccc !important;
    }
    /deep/td{
        border:1px solid #ccc !important;
        padding: 5px 10px;
        text-align: center;
    }
</style>
